/**
 * ParfumChef - Ekstra Esans Sepet Senkronizasyonu
 *
 * Esans line item'ı, bağlı olduğu ana ürünün (_esans_bagli property'sindeki varyant)
 * miktarına eşitlenir:
 *   - Ana ürün sepetten kaldırılırsa esans da kaldırılır.
 *   - Ana ürünün adedi değişirse esans adedi de eşitlenir.
 *   - Esanslı bir form üzerinden (ürün detay, quick-add kartı, quick-add modalı)
 *     ürün eklendiğinde esans satırı yoksa oluşturulur. Esanslı form tespiti:
 *     form içinde .pchef-esans-wrapper (detay/modal) veya product-form-component
 *     üzerinde data-pchef-esans attribute'u (quick-add kartı).
 */
(function () {
  var FEE_VARIANT_ID = window.PCHEF_ESANS_VARIANT;
  if (!FEE_VARIANT_ID) {
    console.warn('[esans] PCHEF_ESANS_VARIANT tanımlı değil, senkronizasyon kapalı.');
    return;
  }
  FEE_VARIANT_ID = String(FEE_VARIANT_ID);

  var running = false;
  var pending = false;

  // Bu sayfada esanslı bir form üzerinden sepete eklendiği bilinen varyantlar.
  // syncEsans bu varyantlar için eksik esans satırını oluşturur.
  var esansliVaryantlar = {};

  function getSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  async function changeLine(key, quantity, sectionIds) {
    var resp = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: sectionIds.join(',') })
    });
    return resp.json();
  }

  async function addLines(items, sectionIds) {
    var resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds.join(',') })
    });
    return resp.json();
  }

  async function syncEsans() {
    if (running) { pending = true; return; }
    running = true;

    try {
      var cart = await (await fetch('/cart.js')).json();

      // Ana ürünlerin (esans olmayan) varyant -> toplam adet haritası
      var anaMiktar = {};
      cart.items.forEach(function (item) {
        if (String(item.variant_id) !== FEE_VARIANT_ID) {
          var k = String(item.variant_id);
          anaMiktar[k] = (anaMiktar[k] || 0) + item.quantity;
        }
      });

      // Mevcut esans satırlarını hedef adetle karşılaştır
      var changes = [];
      var mevcutEsans = {}; // bagli varyant -> esans satırı var
      cart.items.forEach(function (item) {
        if (String(item.variant_id) !== FEE_VARIANT_ID) return;

        var bagli = item.properties && item.properties._esans_bagli;
        if (bagli) mevcutEsans[String(bagli)] = true;
        var hedef = bagli ? (anaMiktar[String(bagli)] || 0) : 0;

        if (item.quantity !== hedef) {
          changes.push({ key: item.key, quantity: hedef });
        }
      });

      // Esanslı formdan eklendiği bilinen ama esans satırı olmayan varyantlar için oluştur
      var additions = [];
      Object.keys(esansliVaryantlar).forEach(function (v) {
        if (anaMiktar[v] && !mevcutEsans[v]) {
          additions.push({
            id: Number(FEE_VARIANT_ID),
            quantity: anaMiktar[v],
            properties: { _esans_bagli: v }
          });
        }
      });

      if (changes.length === 0 && additions.length === 0) return;

      console.log('[esans] düzeltiliyor:', { changes: changes, additions: additions });

      var sectionIds = getSectionIds();
      var lastData = null;
      for (var i = 0; i < changes.length; i++) {
        lastData = await changeLine(changes[i].key, changes[i].quantity, sectionIds);
      }
      if (additions.length > 0) {
        lastData = await addLines(additions, sectionIds);
      }

      // Sepet arayüzünü güncelle
      var freshCart = await (await fetch('/cart.js')).json();
      var evt = new Event('cart:update', { bubbles: true });
      evt.detail = {
        resource: freshCart,
        sourceId: 'esans-sync',
        data: {
          source: 'esans-sync',
          itemCount: freshCart.item_count,
          sections: (lastData && lastData.sections) || {}
        }
      };
      document.dispatchEvent(evt);
    } catch (err) {
      console.error('[esans] senkronizasyon hatası:', err);
    } finally {
      running = false;
      if (pending) { pending = false; syncEsans(); }
    }
  }

  document.addEventListener('cart:update', function (e) {
    var detail = e.detail || {};
    var data = detail.data || {};

    // Kendi tetiklediğimiz senkronizasyonu tekrar işleme (sonsuz döngü önlemi)
    if (data.source === 'esans-sync') return;

    // Esanslı bir formdan başarılı ekleme mi? (detay sayfası, quick-add kartı, quick-add modalı)
    if (data.source === 'product-form-component' && !data.didError && e.target instanceof Element) {
      var form = e.target;
      var esansli = form.hasAttribute('data-pchef-esans') || form.querySelector('.pchef-esans-wrapper');
      if (esansli) {
        var idInput = form.querySelector('[name="id"]');
        var variantId = idInput && idInput.value ? String(idInput.value) : null;
        if (variantId && variantId !== FEE_VARIANT_ID) {
          esansliVaryantlar[variantId] = true;
        }
      }
    }

    syncEsans();
  });

  // Sepet/ödeme sayfası ilk açıldığında da bir kez kontrol et
  document.addEventListener('DOMContentLoaded', syncEsans);
})();
